@if (voiceActiveSectionDisabled) {
  <div>
    <button type="button" (click)="startVoiceRecognition()">Record</button>
  </div>
} @else {
  @if (!voiceActiveSectionError) {
    @if (voiceText) {
      <span>{{ voiceText }}</span>
    } @else {
      @if (voiceActiveSectionListening) {
        <span>Listening...</span>
      } @else {
        <span>Start talking...</span>
      }
    }
  } @else {
    <span>Didn't catch that</span>
  }
  <div>
    <button (click)="closeVoiceRecognition()">Close</button>
    <button (click)="startVoiceRecognition()">Restart</button>
  </div>
}
